module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAAAAAAZai4+AAAA90lEQVR42u3XvWoCQRQFYN//MUaDBhV/WIKQJlGwiQiKut63sVhsJFvPFb5T3uorhuGcQaTMAAsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLKw3r/PdvzlVZbVN60rQVWdvSm21F1rKftazIWvSzFlhYWNVYo5Ss730u1qSj3GOTifV5bUop40tEO8vDGh2jnZfhISLi9JGGtYuIy+Snu+2zsL665vU8bnKwZi/Vqnte1VnT1Uumfvl3qoG/OUvzbZ1yYiQdZFY1FhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFtYbsB7WnQ9DzKnnDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/priAvater.png
// module id = D3Uj
// module chunks = 28